// ----------------------------------------------------------------------

declare module '@mui/system' {
	interface Shape {
		borderRadiusSm: number | string
		borderRadiusMd: number | string
	}
}

const shape = {
	borderRadius: 5,
	borderRadiusSm: 3,
	borderRadiusMd: 8,
}

export default shape
